jQuery(function($) {
    const Scripts = {
        varInit() {
            this.body = $('body');
            this.header = $('header');
            this.document = $(document);
        },

        debounce: function(func, wait, immediate) {
            let timeout;
            return function executedFunction() {
                const context = this;
                const args = arguments;
                const later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                const callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },

        headerScripts() {
            let ctrl = this;
            let menuBtn = $('.burger-btn');
            let searchBtn = $('.header__search-btn');
            let bg = $('.cover-bg');
            let lang = $('.lang');
            let footer_subscribe = $('.menu-item-888');

            footer_subscribe.click(function() {
                $('html, body').animate({
                    scrollTop: $("#form_email_2").offset().top
                }, 500);

            });

            menuBtn.click(function() {
                ctrl.body.removeClass('search-open');
                ctrl.body.toggleClass('menu-open');
                $(this).toggleClass('active');
                searchBtn.removeClass('active');
            });

            searchBtn.click(function() {
                ctrl.body.removeClass('menu-open');
                ctrl.body.toggleClass('search-open');
                $(this).toggleClass('active');
                menuBtn.removeClass('active');
                $('.header-search .search-input').val('').focus();
            });

            bg.click(function() {
                ctrl.body.removeClass('menu-open');
                ctrl.body.removeClass('search-open');
                menuBtn.removeClass('active');
                searchBtn.removeClass('active');
            });

            let mobParentMenu = $('.menu-mobile .menu-item-has-children');
            mobParentMenu.click(function() {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).find('.sub-menu').slideUp(250);
                } else {
                    mobParentMenu.removeClass('active');
                    $('.sub-menu').slideUp(250);
                    $(this).addClass('active');
                    $(this).find('.sub-menu').slideDown(250);
                }
            });

            lang.click(function() {
                $(this).toggleClass('active');
            });

        },

        headerFixed() {
            let ctrl = this;
            let scroll = $(window).scrollTop();

            if (scroll >= 1) {
                ctrl.header.addClass('fixed');
            } else {
                ctrl.header.removeClass('fixed');
            }
        },

        ourWorkSlider() {
            const workImageSlider = new Swiper('.main-work-image-slider', {
                speed: 1000,
                loop: false,
                longSwipesRatio: 0.01,
                parallax: true,
                followFinger: false,
            });
            const workTextSlider = new Swiper('.main-work-text-slider', {
                speed: 1000,
                loop: false,
                followFinger: false,
                autoHeight: true,
                pagination: {
                    el: '.main-work-text-slider__pagination',
                    type: "fraction",
                },
                navigation: {
                    nextEl: '.main-work-text-slider__next',
                    prevEl: '.main-work-text-slider__prev',
                },

            });
            workImageSlider.controller.control = workTextSlider;
            workTextSlider.controller.control = workImageSlider;
        },

        focusSlider() {
            const focusSlider = new Swiper('.main-focus-slider', {
                speed: 1500,
                loop: true,
                followFinger: false,
                pagination: {
                    el: '.main-focus-slider-nav__pagination',
                    type: "fraction",
                },
                navigation: {
                    nextEl: '.main-focus-slider-nav__next',
                    prevEl: '.main-focus-slider-nav__prev',
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
            });
        },

        reportsSlider() {
            const reportsSlider = new Swiper('.annual-reports-slider', {
                speed: 700,
                loop: false,
                followFinger: false,
                pagination: {
                    el: '.annual-reports-slider-nav__pagination',
                    type: "fraction",
                },
                navigation: {
                    nextEl: '.annual-reports-slider-nav__next',
                    prevEl: '.annual-reports-slider-nav__prev',
                },
                slidesPerView: 'auto',
            });
        },

        marquee(selector, speed) {
            const parentSelector = document.querySelector(selector);
            const clone = parentSelector.innerHTML;
            const firstElement = parentSelector.children[0];
            let i = 0;
            parentSelector.insertAdjacentHTML('beforeend', clone);
            parentSelector.insertAdjacentHTML('beforeend', clone);
            parentSelector.insertAdjacentHTML('beforeend', clone);

            setInterval(function() {
                firstElement.style.marginLeft = `-${i}px`;
                if (i > firstElement.clientWidth) {
                    i = 0;
                }
                i = i + speed;
            }, 0);
        },

        clipboard() {
            let copyBlock = $('.copy-btn');

            copyBlock.each(function() {
                $(this).click(function() {
                    let text = $(this).data('copy-text');
                    let icon = $(this).find('.copy-btn__icon');
                    let iconWidth = icon.innerWidth();
                    navigator.clipboard.writeText(text);

                    if ($('.clipboard-popup').length) {
                        $('.clipboard-popup').remove()
                    }

                    let popup = $('<div/>').appendTo('#page');
                    popup.attr('class', 'clipboard-popup').text($(this).data('popup-text'));

                    let position = icon.offset();

                    popup.addClass('active');
                    let popupWidth = popup.innerWidth();
                    let popupHeight = popup.innerHeight();

                    let top = position.top - popupHeight - 10;
                    let left = position.left - popupWidth + iconWidth + 10;

                    if (left < 0) {
                        left = 0;
                    }

                    popup.css({
                        'position': 'absolute',
                        'top': top + 'px',
                        'left': left + 'px'
                    });

                    setTimeout(function() {
                        popup.removeClass('active').removeAttr('style');
                        popup.remove();
                    }, 2000);
                });

            });
        },

        workTabs() {
            let btn = $('.tab-btn');
            let content = $('.tab-content');

            btn.click(function() {
                if (!$(this).hasClass('active')) {
                    btn.removeClass('active');
                    content.removeClass('active');
                    $(this).addClass('active');
                    $(".tab-content[data-tab='" + $(this).data('tab') + "']").addClass('active');
                }
            });
        },

        aboutMenu() {
            //Scroll horizontally with mouse wheel
            const element = document.querySelector(".simplebar-content-wrapper");
            element.addEventListener('wheel', (event) => {
                event.preventDefault();
                element.scrollBy({
                    left: event.deltaY < 0 ? -30 : 30,
                });
            });
            //Auto scroll to current menu item
            let scrollContainer = $('.simplebar-content-wrapper');
            let targetElement = $('.page-nav .current-menu-item');
            let scrollOffset = targetElement.position().left;
            if ((scrollOffset + targetElement.innerWidth()) > $(window).width()) {
                scrollContainer.scrollLeft(scrollOffset);
            }
        },

        switcherLanguagesPosts() {
            let switcher = $('.single-available-languages__switcher');
            let btn = $('.single-available-languages__btn');
            let dropdown = $('.single-available-languages__dropdown');

            btn.click(function() {
                if (switcher.hasClass('switcher-open')) {
                    switcher.removeClass('switcher-open');
                    $(document).off('click.switcherDropdown');
                } else {
                    $(document).off('click.switcherDropdown');
                    switcher.addClass('switcher-open');
                    $(document).on('click.filterDropdown', function(e) {
                        if (!btn.is(e.target) && btn.has(e.target).length === 0 && !dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
                            switcher.removeClass('switcher-open');
                            $(document).off('click.switcherDropdown');
                        };
                    });
                    dropdown.removeClass('right');
                    let dropdownPos = dropdown.offset().left;
                    if ((dropdownPos + dropdown.innerWidth()) > $(window).width()) {
                        dropdown.addClass('right');
                    }
                }
            });
        },

        stickySidebar() {
            let stickyItem = $('.sticky-item');
            let stickyWrap = $('.sticky-wrap');

            if (window.innerWidth >= 1024) {
                $(window).on('scroll.fixedSidebar', function() {
                    let stickyWrapTop = stickyWrap.offset().top;
                    let stickyWrapBottom = stickyWrap.offset().top + stickyWrap.innerHeight();
                    let windowTop = $(window).scrollTop();
                    if (windowTop + 100 + stickyItem.height() > stickyWrapBottom) {
                        stickyItem.addClass('bottom');
                        stickyItem.removeClass('fixed');
                        stickyItem.css('width', stickyWrap.width() + 'px');
                    } else if (stickyWrapTop <= windowTop + 100) {
                        stickyItem.addClass('fixed');
                        stickyItem.removeClass('bottom');
                        stickyItem.css('width', stickyWrap.width() + 'px');
                    } else {
                        stickyItem.removeClass('fixed');
                        stickyItem.removeClass('bottom');
                        stickyItem.removeAttr('style');
                    }
                });
            } else {
                $(window).off('scroll.fixedSidebar');
                stickyItem.removeClass('fixed');
                stickyItem.removeClass('bottom');
                stickyItem.removeAttr('style');
            }
        },

        openFilters() {
            let filtersWrap = $('.filters-block__wrap');
            let filtersList = $('.filters-block__list');
            let filtersWrapBtn = $('.filters-block__btn');

            if (window.innerWidth < 1024 && !filtersWrapBtn.data('clicked')) {
                filtersWrapBtn.data('clicked', true);
                filtersWrapBtn.click(function() {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        filtersWrap.removeAttr('style');
                    } else {
                        $(this).addClass('active');
                        filtersWrap.css('height', filtersList.outerHeight(true) + 'px');
                    }
                });
            } else {
                filtersWrapBtn.removeClass('active');
                filtersWrap.removeAttr('style');
            }
        },

        filters() {
            let filterParams = Scripts._getParameters();

            let wrap = $('.filters-block__wrap');

            let filter = $('.filter');
            let filterBtn = $('.filter__btn');
            let filterDropdownReset = $('.filter-dropdown-reset');
            let filterItem = $('.filter-list-item');

            let apply = $('.filters-block__apply');
            let reset = $('.filters-block__reset');

            filterBtn.click(function() {
                Scripts.__searchFilterReset();
                let thisFilter = $(this).closest('.filter');

                if (thisFilter.hasClass('filter-open')) {
                    thisFilter.removeClass('filter-open');
                    wrap.removeClass('visible');
                    $(document).off('click.filterDropdown');
                } else {
                    let filterDropdown = $(this).next('.filter__dropdown');
                    filter.removeClass('filter-open');
                    $(document).off('click.filterDropdown');
                    thisFilter.addClass('filter-open');
                    wrap.addClass('visible');
                    $(document).on('click.filterDropdown', function(e) {
                        if (!filterBtn.is(e.target) && filterBtn.has(e.target).length === 0 && !filterDropdown.is(e.target) && filterDropdown.has(e.target).length === 0) {
                            filter.removeClass('filter-open');
                            wrap.removeClass('visible');
                            Scripts.__searchFilterReset();
                            $(document).off('click.filterDropdown');
                        };
                    });
                }
            });

            filterDropdownReset.click(function() {
                event.stopPropagation();
                $('.filter-list-item--' + $(this).data('filter-reset')).removeClass('active');
                filterParams = Scripts._getParameters();
            });

            filterItem.click(function() {
                if ($(this).hasClass('single-choice')) {
                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');
                } else {
                    $(this).toggleClass('active');
                }
                filterParams = Scripts._getParameters();
            });

            if ($('.toggles-filter').length) {
                let filterToggles = $('.toggles-filter-item');
                let targetClass = 'active';

                filterToggles.click(function() {
                    let hasTargetClass = $(this).siblings('.active').length > 0;
                    if (hasTargetClass) {
                        $(this).toggleClass('active');
                    } else {
                        filterToggles.addClass('active');
                    }
                    filterParams = Scripts._getParameters();
                });
            }

            if ($('.filter__search').length) {
                let filterSearch = $('.filter__search');

                filterSearch.keydown(function(event) {
                    if (event.keyCode == 13) {
                        Scripts._getFilterPosts();
                        return false;
                    }
                });
            }

            apply.click(function() {
                Scripts._getFilterPosts();
            });

            reset.click(function() {
                filterItem.removeClass('active');
                if ($('.toggles-filter').length) {
                    $('.toggles-filter-item').addClass('active');
                }
                if ($('.filter__search').length) {
                    $('.filter__search').val('');
                }
                Scripts._getFilterPosts();
            });

        },

        _getFilterPosts: function() {
            let l = '';
            if (lang != 'en') {
                l = '/' + lang;
            }

            let filterParams = Scripts._getParameters();
            let postType = $('.filters-block').data('type');
            let tax = $('.filters-block').data('tax');
            let term = $('.filters-block').data('term');
            let path = postType;

            if (tax) {
                path = tax + '/' + term;
            }

            history.pushState('', '', window.location.origin + l + '/' + path + '/' + filterParams['parameters']);

            let data = {
                'action': 'filters',
                'postType': postType,
                'search': filterParams['search'],
                'countries': filterParams['countries'],
                'keywords': filterParams['keywords'],
                'langs': filterParams['langs'],
                'types-resource': filterParams['types-resource'],
                'types-article': filterParams['types-article'],
                'period': filterParams['period'],
                'urlParam': filterParams['parameters'],
                'path': path,
                'tax': tax,
                'term': term
            };

            $.ajax({
                url: ajaxurl,
                data: data,
                type: 'POST',
                success: function(data) {
                    let res = JSON.parse(data);
                    if (res.posts !== '') {
                        $('.resources-wrap, .articles-wrap--main-archive').html(res.posts);
                    }
                    $('.pagination').html(res.pagination);
                }
            });
        }, 

        _getFilterParams: function() {
            let filterParam = [];

            let searchParams = $('.filter__search').val();
            if (searchParams) {
                filterParam['search'] = searchParams;
            }

            if ($('.filter-list-item--countries.active').length) {
                filterParam['countries'] = [];
                filterParam['countries'] = $('.filter-list-item--countries.active').data('filter');
                filterParam['countries-value'] = $('.filter-list-item--countries.active').text().trim();
            }

            if ($('.filter-list-item--keywords.active').length) {
                filterParam['keywords'] = [];
                filterParam['keywords-value'] = [];
                $('.filter-list-item--keywords.active').each(function() {
                    filterParam['keywords'].push($(this).data('filter'));
                    filterParam['keywords-value'].push($(this).text().trim());
                });
            }

            if ($('.filter-list-item--langs.active').length) {
                filterParam['langs'] = [];
                filterParam['langs'] = $('.filter-list-item--langs.active').data('filter');
                filterParam['langs-value'] = $('.filter-list-item--langs.active').text().trim();
            }

            if ($('.filter-list-item--types-article.active').length) {
                filterParam['types-article'] = [];
                filterParam['types-article'] = $('.filter-list-item--types-article.active').data('filter');
                filterParam['types-article-value'] = $('.filter-list-item--types-article.active').text().trim();
            }

            if ($('.filter-list-item--period.active').length) {
                filterParam['period'] = [];
                filterParam['period'] = $('.filter-list-item--period.active').data('filter');
                filterParam['period-value'] = $('.filter-list-item--period.active').text().trim();
            }

            if ($('.toggles-filter-item--types.active').length) {
                filterParam['types-resource'] = [];
                $('.toggles-filter-item--types.active').each(function() {
                    filterParam['types-resource'].push($(this).data('filter'));
                });
            }

            return filterParam;
        },

        _getParameters: function() {
            let parameters = '';
            let filterParams = Scripts._getFilterParams();

            if (filterParams['search']) {
                parameters += '&search=' + filterParams['search'];
            }

            if (filterParams['countries']) {
                parameters += '&countries=' + filterParams['countries'];
                $('.filter--countries').addClass('filter-selected');
                $('.filter--countries').find('.filter__value').text(filterParams['countries-value']);
            } else {
                $('.filter--countries').removeClass('filter-selected');
                $('.filter--countries').find('.filter__value').text(function() {
                    return $(this).data('default-value');
                });
            }

            if (filterParams['keywords'] && filterParams['keywords'].length) {
                parameters += '&keywords=' + filterParams['keywords'];
                $('.filter--keywords').addClass('filter-selected');
                $('.filter--keywords').find('.filter__value').text(filterParams['keywords-value'].join(', '));
            } else {
                $('.filter--keywords').removeClass('filter-selected');
                $('.filter--keywords').find('.filter__value').text(function() {
                    return $(this).data('default-value');
                });
            }

            if (filterParams['langs']) {
                parameters += '&langs=' + filterParams['langs'];
                $('.filter--langs').addClass('filter-selected');
                $('.filter--langs').find('.filter__value').text(filterParams['langs-value']);
            } else {
                $('.filter--langs').removeClass('filter-selected');
                $('.filter--langs').find('.filter__value').text(function() {
                    return $(this).data('default-value');
                });
            }

            if (filterParams['types-article']) {
                parameters += '&types-article=' + filterParams['types-article'];
                $('.filter--types-article').addClass('filter-selected');
                $('.filter--types-article').find('.filter__value').text(filterParams['types-article-value']);
            } else {
                $('.filter--types-article').removeClass('filter-selected');
                $('.filter--types-article').find('.filter__value').text(function() {
                    return $(this).data('default-value');
                });
            }

            if (filterParams['period']) {
                parameters += '&period=' + filterParams['period'];
                $('.filter--period').addClass('filter-selected');
                $('.filter--period').find('.filter__value').text(filterParams['period-value']);
            } else {
                $('.filter--period').removeClass('filter-selected');
                $('.filter--period').find('.filter__value').text(function() {
                    return $(this).data('default-value');
                });
            }

            if (filterParams['types-resource'] && filterParams['types-resource'].length) {
                parameters += '&types-resource=' + filterParams['types-resource'];
            }

            if (parameters.length) {
                parameters = '?' + parameters.slice(1);
            }

            filterParams['parameters'] = parameters;

            return filterParams;
        },

        searchFilter() {
            let filterDropdownSearch = $('.filter-dropdown-search');
            if (filterDropdownSearch.length) {
                filterDropdownSearch.each(function() {
                    let filterDropdownInput = $(this).children('.filter-dropdown-search__input');
                    let thisSearch = $(this);
                    let noResult = $(this).siblings('.filter__search-no-results');
                    filterDropdownInput.keyup(Scripts.debounce(function(event) {
                        let check = true;
                        let searchParams = filterDropdownInput.val().toLowerCase();
                        let filterListItem = thisSearch.next('.filter__list').find('.filter-list-item');
                        filterListItem.each(function() {
                            if (searchParams == '') {
                                $(this).css('display', 'block');
                                check = false;
                            } else if ($(this).text().trim().toLowerCase().indexOf(searchParams) == -1) {
                                $(this).css('display', 'none');
                            } else {
                                $(this).css('display', 'block');
                                check = false;
                            }
                        });
                        if (check) {
                            noResult.show();
                        } else {
                            noResult.hide();
                        }

                    }, 500));

                });
            }
        },

        __searchFilterReset() {
            $('.filter-dropdown-search__input').val('');
            $('.filter-list-item').removeAttr('style');
            $('.filter__search-no-results').hide();
        },
        _arrowUp(){
            const body = $("html, body");

            $(window).scroll(function(){
                if($(document).scrollTop() > $(window).height() * 2){
                    jQuery(".arrow-up").fadeIn(600);
                } else{
                    jQuery(".arrow-up").fadeOut(600);
                }
            });
            $('.arrow-up').on('click',function(e){
                e.preventDefault();
                body.stop().animate({scrollTop:0}, 500);
            });           
        },
        removeAdminMoileClass(){
            $('#wpadminbar').removeClass('mobile');
        },
        fixSquareColor(){
            $("p:contains('■')").html(function(_, html) {
                return html.replace(/■/g, '<span style="color: #00b1b3;">■</span>');
            });
        },

// ADDED FROM PROD START

        scrollAnchor() {
            // Обробка кліків на якорні посилання
            $('a[href*="#"]').on('click', function(event) {
              if (this.hash !== "") {
                var target = $(this.hash);
                
                if (target.length) {
                  event.preventDefault();
          
                  var scrollOffset = target.offset().top - 150;
          
                  $('html, body').animate({
                    scrollTop: scrollOffset
                  }, 800);
                }
              }
            });
          
            // Для завантаження сторінки з якорем
            $(window).on('load', function() {
              if (window.location.hash) {
                // Скидаємо початкове прокручування браузера до якоря
                $('html, body').scrollTop(0);
          
                // Затримка для виконання плавного прокручування
                setTimeout(function() {
                  var target = $(window.location.hash);
                  if (target.length) {
                    var scrollOffset = target.offset().top - 150;
                    $('html, body').animate({
                      scrollTop: scrollOffset
                    }, 800);
                  }
                }, 100); // Невелика затримка, щоб дочекатися повного завантаження сторінки
              }
            });
          },


// ADDED FROM PROD END

        init() {
            Scripts.varInit();
            Scripts.headerScripts();
            Scripts.ourWorkSlider();
            Scripts.focusSlider();
            Scripts.reportsSlider();
            Scripts.removeAdminMoileClass();
            Scripts.scrollAnchor();
            if ($('.marquee').length) {
                Scripts.marquee('.marquee', 0.2);
            }
            Scripts.clipboard();
            Scripts.workTabs();
            if ($('.page-nav').length) {
                Scripts.aboutMenu();
            }
            if ($('.single-available-languages').length) {
                Scripts.switcherLanguagesPosts();
            }
            if (!$('.page-template-front-page').length) {
                Scripts._arrowUp();
            }
            if ($('.sticky-item').length) {
                Scripts.stickySidebar();
            }
            if ($('.filters-block').length) {
                Scripts.openFilters();
                Scripts.filters();
                Scripts.searchFilter();
            }

            Scripts.fixSquareColor();
        },

        
    };

    $(window).resize(function() {
        if ($('.sticky-item').length) {
            Scripts.stickySidebar();
        }
        if ($('.filters-block').length) {
            Scripts.openFilters();
        }
    });

    $(document).ready(function() {
        Scripts.init();

        
    });

    $(document).on('scroll', function() {
        Scripts.headerFixed();
    });
});